import { AuthenticatedApiRequest } from '@goldspotdiscoveries/auth';
import {
  JobsList,
  JobsQuery,
  JobsResponse,
  ModelPathListResponse,
  getPathListParams,
} from '../../TypeScript/interfaces';

/**
 * Get list of jobs
 */
export const getJobsList = (
  company: string,
  project: string,
  queryParams?: JobsQuery,
): Promise<JobsList> => {
  return new Promise((resolve, reject) => {
    const params: string[] = [];
    Object.keys(queryParams || {}).forEach((key: string): void => {
      const value: string = (queryParams || ({} as any))[key];
      if (typeof value !== 'undefined' && value !== null && value !== '') {
        params.push(`${key}=${value}`);
      }
    });
    AuthenticatedApiRequest({
      method: 'get',
      apiName: 'Projects',
      path: `/${company}/${project}/jobs?${params.join('&')}`,
    })
      .then((result: any) => {
        const jobsList: JobsList = result;
        resolve(jobsList);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

/**
 * Get details of one job
 */
export const getJobInfo = (
  company: string,
  project: string,
  jobId: string,
): Promise<JobsResponse> => {
  return new Promise((resolve, reject) => {
    AuthenticatedApiRequest({
      method: 'get',
      apiName: 'Projects',
      path: `/${company}/${project}/jobs/${jobId}`,
    })
      .then((result: any) => {
        const jobInfo: JobsResponse = result;
        resolve(jobInfo);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

/**
 * Create new job
 */
export const putNewJob = (
  company: string,
  project: string,
  body: any,
): Promise<JobsResponse> => {
  return new Promise((resolve, reject) => {
    AuthenticatedApiRequest({
      method: 'put',
      apiName: 'Projects',
      path: `/${company}/${project}/jobs`,
      postData: { body },
    })
      .then((result: any) => {
        const job: JobsResponse = result;
        resolve(job);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getColorClusterModels = (
  company: string,
  project: string,
  queryParams?: getPathListParams,
): Promise<ModelPathListResponse> => {
  return new Promise((resolve, reject) => {
    const path = `!_LITHOLENS-DATA/03_MachineLearning/01_Models/02_Clusters/01_CorePhotos/`;
    const params: string[] = Object.keys(queryParams || {}).map(
      (key: string): string => {
        const value: string = (queryParams || ({} as any))[key];
        if (typeof value === 'undefined' || value === null || value === '') {
          return '';
        } else {
          return `${key}=${value}`;
        }
      },
    );
    AuthenticatedApiRequest({
      method: 'get',
      apiName: 'Files',
      path: `/${company}/${project}/${path}?${params.join('&')}`,
    })
      .then((result: any) => {
        let modelList: ModelPathListResponse = result;
        resolve(modelList);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

/**
 * Update job
 */
export const updateJob = (
  company: string,
  project: string,
  jobId: string,
  body: any,
): Promise<JobsResponse> => {
  return new Promise((resolve, reject) => {
    AuthenticatedApiRequest({
      method: 'post',
      apiName: 'Projects',
      path: `/${company}/${project}/jobs/${jobId}`,
      postData: { body },
    })
      .then((response: any) => {
        const job: JobsResponse = response;
        resolve(job);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

/**
 * Archive job
 */
export const archiveJob = (
  company: string,
  project: string,
  jobId: string,
): Promise<void> => {
  return new Promise((resolve, reject) => {
    AuthenticatedApiRequest<{ message: string }>({
      method: 'post',
      apiName: 'Projects',
      path: `/${company}/${project}/jobs/${jobId}/archive`,
    })
      .then((_response: { message: string }) => {
        resolve();
      })
      .catch((err) => {
        reject(err);
      });
  });
};

/**
 * Unarchive job
 */
export const unArchiveJob = (
  company: string,
  project: string,
  jobId: string,
): Promise<void> => {
  return new Promise((resolve, reject) => {
    AuthenticatedApiRequest<{ message: string }>({
      method: 'delete',
      apiName: 'Projects',
      path: `/${company}/${project}/jobs/${jobId}/archive`,
    })
      .then((_response: { message: string }) => {
        resolve();
      })
      .catch((err) => {
        reject(err);
      });
  });
};
